import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/stress-test/$scenarioId")({
	component: RouteComponent,
});

function RouteComponent() {
	return <Navigate to="/stress-test/results" />;
}
